import CardPreview from './card-preview';

export default CardPreview;